import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-non-closable-error.dialog',
  templateUrl: './non-closable-error.dialog.component.html',
  styleUrl: './non-closable-error.dialog.component.scss'
})
export class NonClosableErrorDialogComponent {
  dialogData? = inject<string>(MAT_DIALOG_DATA);
}
